// @flow
import * as React from 'react';
import type { IAPReason } from './IAPReason';

export type SubmissionForm = {|
  +comment?: string,
|};

type Action =
  | {|
      type: 'changeReason',
      payload: {|
        reason: IAPReason,
        validator?: SubmissionForm => boolean,
      |},
    |}
  | {|
      type: 'modifyBody',
      payload: SubmissionForm,
    |}
  | {|
      type: 'disableSubmission',
    |};

type State = {|
  selected: IAPReason | null,
  validator?: SubmissionForm => boolean,
  form: { +[IAPReason]: SubmissionForm },
|};

const reducer = (state: State, action: Action) => {
  if (action.type === 'changeReason') {
    return {
      selected: action.payload.reason,
      validator: action.payload.validator,
      form: state.form,
    };
  }
  if (action.type === 'modifyBody' && state.selected) {
    return {
      selected: state.selected,
      validator: state.validator,
      form: { ...state.form, [state.selected]: action.payload },
    };
  }

  throw new Error(`Tried to dispatch action type ${action.type} that does not exist`);
};

type InitialFormState = {|
  reason: IAPReason,
  validator?: SubmissionForm => boolean,
|};

const useReportForm = (initialValue?: InitialFormState) => {
  const [state, dispatch] = React.useReducer<_, Action>(reducer, {
    selected: initialValue ? initialValue.reason : null,
    validator: initialValue && initialValue.validator,
    form: {},
  });
  return React.useMemo(() => {
    const form = (state.selected && state.form[state.selected]) || { comment: undefined };
    return [
      {
        selected: state.selected,
        disabled: !state.selected || (state.validator && !state.validator(form)),
        form,
      },
      dispatch,
    ];
  }, [state]);
};

export type ReportFormDispatcher = Action => void;

export default useReportForm;
